<div class="dates">
  <ui-input-select [value]="month" [customWidth]="'90px'" [datepicker_left_radius]="true" placeholder="Mes" [valueOptions]="months"
    [labelColor]="'gray'"></ui-input-select>
  <ui-input-select [value]="year" [customWidth]="'90px'" [datepicker_right_radius]="true" placeholder="Año" [valueOptions]="years"
    [labelColor]="'gray'"></ui-input-select>
</div>
